export default __webpack_public_path__ + "static/media/aliPay.d2a541e1.png";